import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';
import { BackendService } from '../../core/backend.service';

import { DialogService } from '../../shared-components/modals/dialog.service';

import { ImagenService } from '../../core/imagen.service.';
import { DomSanitizer } from '@angular/platform-browser';
import { Logo } from '../../cliente/logo.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { EstadoCliente } from '../../cliente/estadoCliente.model';
import { Cliente } from '../../cliente/cliente.model';
import { Page } from '../../shared-components/generic-list/generic-list.component';

@Component({
  selector: 'app-acuerdo-logo-viewer',
  templateUrl: './acuerdo-logo-viewer.component.html',
  styleUrls: ['./acuerdo-logo-viewer.component.scss']
})
export class AcuerdoLogoViewerComponent implements OnInit {
  @Input() logos: Logo[] = [];
  @Input() editable = false;

  private re = /(?:\.([^.]+))?$/;

  logosList = [];

  page = 0;
  size = 3;
  totalItems = 0;
  isLoading = false;

  seleccionarArchivo = 'Seleccionar imágen';
  constructor(
    private clienteService: ClienteService,
    private backendService: BackendService,
    private snackService: SnackService,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private dialogService: DialogService) { }

  ngOnInit() {
    this.totalItems = this.logos.length;
    if (this.logos.length === 0) {
      this.agregarImagen();
    }
    const imgs = [];
    this.logos.forEach(i => {
      const img = new Logo(null);
      img.id = i.id;
      img.name = i.name;
      img.path = i.path;
      if (i.path && i.path.indexOf('http') < 0) {
        this.getImages(img);
      } else {
        img.url = i.path + i.name;
      }

      imgs.push(img);
    });
    this.logos.splice(0);
    imgs.forEach(i => this.logos.push(i));
    this.getLogos();
  }

  getImages(imagen: Logo) {
    this.clienteService.getLogoById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.url = safeUrl;
    });
  }

  agregarImagen() {
    this.logos.push(new Logo(undefined));
  }
  eliminarImagen(index: number) {
    if (this.logos[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar el logo ' + this.logos[index].path
       + '?')
      .then( res => {
        if (res) {
          this.deleteFromDb(this.logos[index].id);
          this.logos.splice(index, 1);
          if (this.logos.length === 0) {
            this.logos.push(new Logo(undefined));
          }
        }
      });
    } else {
      this.logos.splice(index, 1);
    }
  }
  deleteFromDb(id: number) {
    this.backendService.delete(Cliente.path + 'eliminar-logo/' + id);
  }
  addFile(event, index: number) {
    if (this.soloImagenesOPdf(event.target.files[0].name)) {
      this.logos[index].file = event.target.files[0];
      this.logos[index].path = event.target.files[0].name;
      this.logos[index].name = event.target.files[0].name;
      this.logos[index].id = undefined;
    }
  }

  soloImagenesOPdf(fileName: string) {
    let ext = this.re.exec(fileName)[1];
    ext = ext.toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'pdf') {
      this.snackService.error('Solo estan permitidos archivos de tipo ".png", ".jpg" o ".pdf"');
      return false;
    }
    return true;
  }


  private openWindow(img: Logo) {
    this.dialogService.imageViewer(img.name, '', img.url);
    // window.open(img.url, '_blank');
  }

  onPageChange(page: Page) {
    this.page = page.pageIndex;
    this.size = page.pageSize;
    this.getLogos();
  }

  getLogos() {
    const init = this.page * this.size;
    this.logosList = this.logos.slice(init, (init + this.size) > this.logos.length ? this.logos.length : init + this.size );
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-logo-viewer/acuerdo-logo-viewer.component.ts